import type { TemplateListItem } from '@/lib/templates/types/template-list-item'

/**
 * Client-side name filter — neither template endpoint takes a name-search query param (see
 * `templates.service.ts`), so this matches Backgrounds' own `filterBackgroundsByFilename`: plain
 * case-insensitive substring match against `templateName`.
 */
export function filterTemplatesByName(
  templates: TemplateListItem[],
  query: string
): TemplateListItem[] {
  const trimmed = query.trim()

  if (!trimmed) return templates

  const needle = trimmed.toUpperCase()

  return templates.filter((template) => template.templateName.toUpperCase().includes(needle))
}
